import React, { Component } from 'react';
import { TextField, Checkbox, FormControlLabel, Grid, DialogTitle, DialogContent, DialogActions, Dialog, Button, Table, TableBody, TableRow, TableCell, TableHead } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../../auth/store/actions';
import { withStyles } from '@material-ui/core/styles';
import * as validatorActions from '../../components/validator/store/actions'
import * as companyActions from '../company/store/actions';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Chip from '@material-ui/core/Chip';


const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    open: false
});

class AuthForm extends Component {

    state = {
        uncheckRoleDialog: false,
        targetRole: {
            RoleName: 'placeholder'
        },
        open: false
    }

    constructor(props) {
        super(props);
        this.props.getCompanyList()
        this.state = { ...this.state }
    }

    componentDidMount = () => {
        if (this.props.preloadRole.active) {
            this.props.updateAuthRole(this.props.preloadRole.role, 'add')
        }
        if (this.props.companyAuth.company_id != 0) {
            const validator = {
                field_name: 'company_ids', value: [this.props.companyAuth.company_id]
            }
            this.props.runValidator(validator, this.props.validator)
        }
    }

    handleChange = field_name => event => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        const validator = {
            field_name, value
        }
        this.props.runValidator(validator, this.props.validator)
        this.props.updateAuthForm(update_data);
    }

    handleCompanyChange = field_name => event => {
        this.setState({ open: false })
        let value = event.target.value;
        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }
        this.props.runValidator(validator, this.props.validator)
        this.props.updateAuthCompanies(update_data)
    }

    getRoleChecked = (row) => {
        if (this.props.currentAuth.roles.filter(role => role.role_id === row.role_id).length > 0) {
            return true
        }
        return false
    }

    getRoleDisabled = (row) => {
        let disable_status = false;

        switch (this.props.auth.user.role) {
            case ("dev"):
                {
                    disable_status = false;
                    break;
                }

            case ("admin"):
                {
                    if (row.role_id === 1) {
                        disable_status = true;
                    }
                    break;
                }

            default: { }
        }

        return disable_status;
    }

    handleClickRole = (role, clicked) => {
        if (clicked) {
            this.setState({ uncheckRoleDialog: true, targetRole: role })
        }
        else {
            this.props.updateAuthRole(role, 'add')
        }
    }

    deactivateRole = (role) => {
        this.props.updateAuthRole(role, 'remove')
        this.setState({ uncheckRoleDialog: false, targetRole: { RoleName: 'placeholder' } })
    }

    fieldHasError = (rows) => {
        for (let row of rows) {
            if (row.error) {
                return true
            }
        }
        return false
    }

    getDeactivateDialog = (active, role) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ uncheckRoleDialog: false })}
            >
                <DialogTitle>Confirm Remove Role {role.RoleName} ?</DialogTitle>
                <DialogContent>
                    This will delete all related data to the role.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.deactivateRole(role)} color="primary">
                        Remove
                        </Button>
                    <Button onClick={() => this.setState({ uncheckRoleDialog: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getRoleCheckboxes = (auth_roles) => {
        return auth_roles.map((role) => {
            const checked = this.getRoleChecked(role);
            const is_disabled = this.getRoleDisabled(role);

            return (
                <Grid item xs={12} key={role.role_id}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                disabled={is_disabled}
                                style={{ marginLeft: '5px' }}
                                checked={checked}
                                onChange={() => this.handleClickRole(role, checked)}
                                color="primary"
                            />
                        }
                        label={role.RoleName}
                    />
                </Grid>
            );
        });
    }

    getRoleColumn = (row) => {
        if (row.role_id === 1 || row.role_id === 2 || row.role_id === 4) {
            return row.RoleName
        }
        return row.RoleName + ' (' + row.CompanyName + ')'
    }

    componentWillMount = () => {
        const curAuthRole = this.props.auth.user.role;
        if (curAuthRole === 'company') {
            this.props.updateAuthCompanies({ company_ids: [this.props.auth.user.data.role_info.company_id] })
            this.props.runValidator({ field_name: 'company_ids', value: [this.props.auth.user.data.role_info.company_id] }, this.props.validator)
        }
    }

    dropCompany = (id) => {
        const company_ids = this.props.companyInfo.company_ids;
        const filtered = company_ids.filter(c => c != id)
        this.props.dropCompany(id)
        this.props.runValidator({ field_name: 'company_ids', value: filtered }, this.props.validator)
    }

    render() {
        const { classes, currentAuth, view_type, validator, companyInfo } = this.props
        const auth_roles = [
            { RoleName: 'Dev', role_id: 1 },
            { RoleName: 'Admin', role_id: 2 },
            { RoleName: 'Instructor', role_id: 3 },
            { RoleName: 'Student', role_id: 4 },
            { RoleName: 'Company', role_id: 5 }
        ]

        const auth_role_checkboxes = this.getRoleCheckboxes(auth_roles);

        const companyItems = this.props.allCompanies.map(c => {
            return (
                <MenuItem key={c.company_id} value={c.company_id}>{c.CompanyName}</MenuItem>
            )
        })

        const getCompanyNameByID = (id) => {
            if (this.props.allCompanies.length === 0 || !this.props.companyInfo.company_ids) {
                return ''
            }
            return this.props.allCompanies.filter(c => c.company_id === id)[0].CompanyName
        }

        const loginTable = this.props.currentAuth.roles.map(row => (
            <TableRow key={row.link_id + '-' + row.company_id}>
                <TableCell>{this.getRoleColumn(row)}</TableCell>
                <TableCell>{row.LastLogin || 'None'}</TableCell>
            </TableRow>
        ))

        const companySelect = () => {
            let helper = <FormHelperText>Company must be selected for this User</FormHelperText>;
            const devRole = currentAuth.roles.filter(r => r.role_id === 1);
            if (devRole.length > 0 && currentAuth.roles.length === 1 || view_type === 'detail') {
                helper = null
            }
            const multiCompanyRoles = ['dev', 'admin']
            const curAuthRole = this.props.auth.user.role

            const companySelector = (isDisabled) => (
                <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-age-simple"

                    >
                        Company
                        </InputLabel>
                    <Select
                        open={this.state.open}
                        onOpen={() => this.setState({ open: true })}
                        onClose={() => this.setState({ open: false })} 
                        className={classes.textField}
                        multiple
                        id="company_ids"
                        error={validator.filter(v => v.field_name === 'company_ids')[0].error}
                        disabled={view_type === 'detail' || isDisabled}
                        value={this.props.companyInfo.company_ids}
                        onChange={this.handleCompanyChange('company_ids')}
                        
                        input={
                            <OutlinedInput
                                labelWidth={70}
                                name="Company"
                                id="outlined-age-simple"
                            />
                        }
                        renderValue={selected => (
                            <div style={{ whiteSpace: 'normal' }}>
                                    {selected.map(c => (
                                        <Chip style={{ marginTop: '3px' }} key={c} label={getCompanyNameByID(c)} className={classes.chip} onDelete={() => { document.activeElement.blur(); this.dropCompany(c)}}/>
                                    ))}
                            </div>
                        )}
                    >
                        {companyItems}
                    </Select>
                    {helper}
                </FormControl>
            )

            if (this.props.companyAuth.active) {
                if (multiCompanyRoles.includes(curAuthRole)) {
                    return companySelector(false)
                }
                else {
                    return companySelector(true)
                }
            }
            else {
                if (multiCompanyRoles.includes(curAuthRole)) {
                    return companySelector(false)
                }
                else {
                    return companySelector(true)
                }
            }
        }
        // taking this out for now, passwords will be generated
        const passwordCreate = (prop) => {
            if (prop) {
                return (
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="Password"
                            label="Password"
                            className={classes.textField}
                            value={currentAuth.Password}
                            onChange={this.handleChange('Password')}
                            margin="normal"
                            variant="outlined"
                            type="password"
                            // error={this.fieldHasError(validator.filter(v => v.field_name === 'Password'))}
                            error={currentAuth.Password != currentAuth.PasswordConfirm || validator.filter(v => v.field_name === 'Password')[0].error}
                            helperText={validator.filter(v => v.field_name === 'Password')[0].error_msg}
                            autoComplete='new-password'
                        />
                        <TextField
                            required
                            id="PasswordConfirm"
                            label="Password Confirm"
                            className={classes.textField}
                            value={currentAuth.PasswordConfirm}
                            onChange={this.handleChange('PasswordConfirm')}
                            margin="normal"
                            variant="outlined"
                            type="password"
                            error={currentAuth.Password != currentAuth.PasswordConfirm || validator.filter(v => v.field_name === 'PasswordConfirm')[0].error}
                            // error={this.fieldHasError(validator.filter(v => v.field_name === 'PasswordConfirm'))}
                            helperText={"Must match the 'Password' field"}
                            autoComplete='new-password'
                        />
                    </Grid>
                )
            }
        }

        const uncheckRoleDialog = this.getDeactivateDialog(this.state.uncheckRoleDialog, this.state.targetRole)
        return (
            <div className="p-24">
                {uncheckRoleDialog}
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <form className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="FirstName"
                                    label="First Name"
                                    className={classes.textField}
                                    value={currentAuth.FirstName}
                                    onChange={this.handleChange('FirstName')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                // error={validator.filter(v => v.field_name === 'FirstName')[0].error}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="LastName"
                                    label="Last Name"
                                    className={classes.textField}
                                    value={currentAuth.LastName}
                                    onChange={this.handleChange('LastName')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="Email"
                                    label="Email"
                                    className={classes.textField}
                                    value={currentAuth.Email}
                                    onChange={this.handleChange('Email')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                    error={validator.filter(v => v.field_name === 'Email')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'Email')[0].error_msg}
                                    autoComplete='new-email'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {companySelect()}
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="Address"
                                    label="Address"
                                    className={classes.textField}
                                    value={currentAuth.Address}
                                    onChange={this.handleChange('Address')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="City"
                                    label="City"
                                    className={classes.textField}
                                    value={currentAuth.City}
                                    onChange={this.handleChange('City')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="State"
                                    label="State"
                                    className={classes.textField}
                                    value={currentAuth.State}
                                    onChange={this.handleChange('State')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="Zip"
                                    label="Zip"
                                    className={classes.textField}
                                    value={currentAuth.Zip}
                                    onChange={this.handleChange('Zip')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    id="Phone"
                                    label="Phone"
                                    className={classes.textField}
                                    value={currentAuth.Phone}
                                    onChange={this.handleChange('Phone')}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={view_type === 'detail'}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {view_type === 'edit' ?
                                    <Button onClick={() => this.props.history.push('/user/change_password/' + currentAuth.auth_id)} variant="contained" className={classes.button}>
                                        Change User Password
                                    </Button>
                                    : null}
                            </Grid>
                        </form>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid item xs={12}>
                            {auth_role_checkboxes}

                        </Grid>
                    </Grid>
                </Grid>
            </div >
        )
    }
}



function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAuth: Actions.getAuth,
        saveAuth: Actions.saveAuth,
        getAuthList: Actions.getAuthList,
        updateAuthForm: Actions.updateAuthForm,
        updateAuthRole: Actions.updateAuthRole,
        runValidator: validatorActions.runValidator,
        getCompanyList: companyActions.getCompanyList,
        updateAuthCompanies: Actions.updateAuthCompanies,
        dropCompany: Actions.dropCompany
    }, dispatch);
}

function mapStateToProps({ auth, validator, companyApp }) {
    return {
        auth: auth,
        currentAuth: auth.crud.currentAuth,
        validator: validator.list,
        allCompanies: companyApp.companies.companyList,
        companyInfo: auth.crud.companyInfo
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthForm)));


// WEBPACK FOOTER //
// src/main/content/auth/AuthForm.js